import { createApp } from "vue"
import ProductVariants from "./App.vue"

createApp(ProductVariants)
    .mount("[data-product-variants]")
